import { urls as LightningUrls } from 'lightning-common/lib/configuration';

import { getHtmlCopy } from '../../i18n';
import { AppleAppStoreBadge } from '../app-badge/AppleAppStoreBadge';
import { GooglePlayStoreBadge } from '../app-badge/GooglePlayStoreBadge';
import { LogoLibbyWhite } from '../logos';
import { FooterPromoColumn } from './FooterPromos';
import {
    KindleFireText,
    KindleFireTextProps,
} from '../kindle-fire-text/KindleFireText';

import './FooterLibbyPromoColumn.scss';

interface FooterLibbyPromoColumnProps {
    ntcMode?: boolean;
    openInNewWindow?: boolean;
    showKindlePromo?: boolean;
}

const KINDLE_FIRE_OVERRIDE: KindleFireTextProps = {
    includePeriod: true,
    hrefOverride: {
        gaParameters: [
            { key: 'utm_medium', value: 'lightning_footer' },
            { key: 'utm_source', value: 'ntc' },
            { key: 'utm_campaign', value: 'ntc_lightning' },
            { key: 'utm_content', value: 'ntc_getlibby_footer' },
        ],
    },
};

export const FooterLibbyPromoColumn = ({
    ntcMode,
    openInNewWindow,
    showKindlePromo,
}: FooterLibbyPromoColumnProps) => (
    <FooterPromoColumn
        logo={<LogoLibbyWhite />}
        openInNewWindow={openInNewWindow}
        showKindlePromo={showKindlePromo}
        tagLine={'footer.theLibraryReadingAppSentance'}
    >
        <ul
            aria-label={getHtmlCopy('libby.brandName')}
            className="footer__libby-promo-column-list"
        >
            <li>
                {!ntcMode && (
                    <AppleAppStoreBadge
                        href={LightningUrls.iOSLibbyFooterUrl}
                        variant="white"
                    />
                )}
                {ntcMode && (
                    <AppleAppStoreBadge
                        href={LightningUrls.ntcIosLibbyFooterUrl}
                        variant="white"
                    />
                )}
            </li>
            <li>
                {!ntcMode && (
                    <GooglePlayStoreBadge
                        href={LightningUrls.androidLibbyFooterUrl}
                        variant="white"
                    />
                )}
                {ntcMode && (
                    <GooglePlayStoreBadge
                        href={LightningUrls.ntcAndroidLibbyFooterUrl}
                        variant="white"
                    />
                )}
            </li>
        </ul>
        {ntcMode && (
            <ul className="footer__libby-promo-kindle">
                <KindleFireText {...KINDLE_FIRE_OVERRIDE} />
            </ul>
        )}
    </FooterPromoColumn>
);
